import React from "react"

export default () => <div className="app-bg"></div>